// extracted by mini-css-extract-plugin
export var picker = "_d-0";